import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Usage: data-controller="change-stage-modal"
// Handles dynamic stage selection for funding programs
export default class extends Controller {
  static targets = ["modal", "form", "programName", "stageRadio"];
  static values = {
    baseUrl: String
  };

  connect() {
    if (this.hasModalTarget) {
      this.modalTarget.addEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
    }
  }

  disconnect() {
    if (this.hasModalTarget) {
      this.modalTarget.removeEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
    }
  }

  open(event) {
    event.preventDefault();
    
    const programId = event.currentTarget.dataset.programId;
    const programName = event.currentTarget.dataset.programName;
    const currentStage = event.currentTarget.dataset.currentStage;
    
    // Update the form action URL
    const formUrl = this.baseUrlValue.replace(':id', programId);
    this.formTarget.action = formUrl;
    
    // Update the program name in the modal
    this.programNameTarget.textContent = programName;
    
    // Select the current stage radio button
    this.stageRadioTargets.forEach(radio => {
      radio.checked = radio.value === currentStage;
    });
    
    // Show the modal using Bootstrap
    const modal = new Modal(this.modalTarget);
    modal.show();
  }

  _handleModalHidden() {
    // Reset radio buttons
    this.stageRadioTargets.forEach(radio => {
      radio.checked = false;
    });
  }
}
